import React from "react";

export const NotificationCount = ({ count }) => {
  return (
    <div className='bg-[#00B278] text-white font-[&quot;public_sans&quot;] rounded-full w-5 h-5 lg:w-4 lg:h-4 xl:w-[21px] xl:h-[22px] text-[10px] xl:text-sm font-normal flex items-center justify-center p-[6px]'>
      {count}
    </div>
  );
};
